import {useCallback, useContext} from "react";
import {useQuery} from '@tanstack/react-query';
import useStaffUserLookup from "@components/common/hooks/useStaffUserLookup";
import {getSessionName, getSessionOrder} from "@components/Pages/Events/Sessions/sessionFunctions";
import {API_URLS, axiosRequest} from "@lib/axios";
import UserContext from "@lib/contexts/userContext";
import moment from '@lib/moment';

/**
 * React Query wrapper for Session details
 */
const useSessionDetailsQuery = (id) => {
  const { authenticated } = useContext(UserContext);
  const { usersLoading, setMetadataNames } = useStaffUserLookup();

  const select = useCallback((session) => {
    session.name = getSessionName({
      session,
      dateFallback: true,
      useNill: false,
    });
    session.mStart = moment(session.start);
    session.mEnd = moment(session.end);
    session.multiday = session.mEnd.diff(session.mStart, 'minutes') > ((24*60) - 1);
    session.sessionOrder = getSessionOrder(session);

    setMetadataNames(session);

    return session;
  }, [setMetadataNames]);
  
  return useQuery({
    queryKey: ['sessions', id],
    queryFn: async () => axiosRequest({ method: 'GET', url: `${API_URLS.SESSIONS}/${id}`}),
    enabled: authenticated && !usersLoading,
    select,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default useSessionDetailsQuery;
